<template>
  <nav class="nav" v-if="isFooter">
    <div class="btm__icon" :class="{on: $route.path === '/main/home'}" @click="$router.push('/main/home').catch(() => {})">
      <div class="img home"></div>
      <p>홈</p>
    </div>
    <div class="btm__icon" :class="{on: $route.path === '/main/select' || $route.path === '/main/progress' || $route.path === '/main/report' }" @click="$router.push('/main/select').catch(() => {})">
      <div class="img report"></div>
      <p>서비스</p>
    </div>
    <div class="btm__icon" :class="{on: $route.path === '/main/message'}" @click="$router.push('/main/message').catch(() => {})">
      <div class="img bill"></div>
      <p>문의하기</p>
    </div>
    <div class="btm__icon" :class="{on: $route.path === '/mypage'}" @click="$router.push('/mypage').catch(() => {})">
      <div class="img mypage"></div>
      <p>마이페이지</p>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'FooterBar',
  props: {
    fullPath: {
      type: String,
      description: 'on/off를 하기위한 $route.fullPath'
    },
    isFooter: {
      type: [Boolean],
      description: 'isFooter 상태',
      default: () => false
    }
  }
}
</script>

<style>
/*nav {*/
/*  position: fixed;*/
/*  width: 100%;*/
/*  bottom: 0;*/
/*}*/
</style>
